import { render, staticRenderFns } from "./live-cattle.vue?vue&type=template&id=2fcfd4e7&scoped=true&"
import script from "./live-cattle.vue?vue&type=script&lang=js&"
export * from "./live-cattle.vue?vue&type=script&lang=js&"
import style0 from "./live-cattle.vue?vue&type=style&index=0&id=2fcfd4e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcfd4e7",
  null
  
)

export default component.exports